// Canonical product-label formatting (frontend mirror of redis_dev/helpers/productLabel.js).
// A cable with a reduced green-yellow (earth) conductor reads "<nc>x<section>+<gy>",
// e.g. "3x25+16" / "CYABYF 3x25+16". The +gy suffix appears only when
// greenYellowSection is a positive number that differs from the phase section.

export const hasReducedGy = (section, greenYellowSection) => {
  const gy = greenYellowSection;
  return (
    gy != null &&
    String(gy).trim() !== '' &&
    Number(gy) > 0 &&
    Number(gy) !== Number(section)
  );
};

// "25" -> "25"   |   section 25 + gy 16 -> "25+16"
export const formatSectionSpec = (section, greenYellowSection) => {
  const sec = section ?? '';
  return hasReducedGy(section, greenYellowSection) ? `${sec}+${greenYellowSection}` : `${sec}`;
};

// "3x25" or "3x25+16"
export const formatCoreSpec = ({ numberOfConductors, section, greenYellowSection } = {}) =>
  `${numberOfConductors ?? ''}x${formatSectionSpec(section, greenYellowSection)}`;

// "CYABYF 3x25+16"  (accepts name OR cableName)
export const formatProductLabel = (o = {}) => {
  const name = o.name ?? o.cableName ?? '';
  const core = formatCoreSpec(o);
  return name ? `${name} ${core}`.trim() : core;
};

// just the "+16" suffix (or '') — handy for appending to an existing label/section text
export const gySuffix = (section, greenYellowSection) =>
  hasReducedGy(section, greenYellowSection) ? `+${greenYellowSection}` : '';
